// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"product-image_imgContainer__2M1aL","img":"product-image_img__9Qsb1","unavailable":"product-image_unavailable__KTI5_"};